import React from 'react';
import { Button, Flex } from '@cognite/cogs.js';
import { DrawerWithTitle } from 'pages/ViewDigitalTwinPage/components/Schemas/ViewSchemaPage/ProjectRuleset/components/DrawerWithTitle';
import { DrawerSteps } from 'components/DrawerSteps/DrawerSteps';
import { DigitalTwin } from 'types/graphql-apollo-v2';
import { ConsistencyRuleView, ConsistencySchemaFilterView } from '../types';
import { useEditConsistencyRuleDrawer } from './useEditConsistencyRuleDrawer';
import { buildRuleSteps } from '../NewConsistencyRuleDrawer.steps';

type EditConsistencyRuleDrawerProps = {
  visible: boolean;
  onClose: VoidFunction;
  rule: ConsistencyRuleView | undefined;
  schemaFilters: ConsistencySchemaFilterView[];
  digitalTwin: DigitalTwin;
};

export const EditConsistencyRuleDrawer = ({
  visible,
  onClose,
  rule,
  schemaFilters,
  digitalTwin,
}: EditConsistencyRuleDrawerProps) => {
  const hookResult = useEditConsistencyRuleDrawer({
    rule,
    visible,
    onClose,
    schemaFilters,
    digitalTwin,
  });

  const {
    currentStep,
    setCurrentStep,
    creating,
    hasInvalidValues,
    onSaveRule,
    onCancelHandler,
  } = hookResult;

  const steps = buildRuleSteps({
    ...hookResult,
    schemaFilters,
    isEditing: true,
  });

  return (
    <DrawerWithTitle
      title="Edit comparison rule"
      visible={visible}
      onCancel={onCancelHandler}
      footer={
        <Flex justifyContent="flex-end" alignItems="center" gap={8}>
          <Button onClick={onCancelHandler} disabled={creating}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => void onSaveRule()}
            loading={creating}
            disabled={creating || hasInvalidValues}
          >
            Save
          </Button>
        </Flex>
      }
    >
      <DrawerSteps
        steps={steps}
        currentStep={currentStep}
        onChangeStep={setCurrentStep}
      />
    </DrawerWithTitle>
  );
};
